import { Component, OnInit, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { goBackToHistory } from "../utils/history-navigation-utils";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { User } from "src/app/model/login";
import { getSourceByField, SourceItem } from 'src/app/utils/source-utils';
import { HttpClient } from '@angular/common/http';
import * as moment from "moment";
import { ResultCriminalComponent } from "../result-criminal/result-criminal.component";
import { NewPrintHistoryBodyComponent } from "./new-print-history-body/new-print-history-body.component";
@Component({
  selector: 'app-new-print-history',
  templateUrl: './new-print-history.component.html',
  styleUrls: ['./new-print-history.component.scss']
})
export class NewPrintHistoryComponent implements OnInit {
  @ViewChild(NewPrintHistoryBodyComponent) printBodyComponent: NewPrintHistoryBodyComponent;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataServiceService,
    private authService: AuthService,
    private http: HttpClient,
    private location: Location,
  ) {}

  ngOnInit(): void {}

  goBack() {
    goBackToHistory(this.location);
  }

  savePageRecord() {
    this.callChildComponentMethod()
  }

  callChildComponentMethod() {
    if (this.printBodyComponent) {
      this.printBodyComponent.saveRecord();
    }
  }
} 